import { render, staticRenderFns } from "./SocialSetting.vue?vue&type=template&id=683d9e6e&"
import script from "./SocialSetting.vue?vue&type=script&lang=js&"
export * from "./SocialSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports